import {api_url, languages, upload_path} from "../../_AE/Helpers";

// console.log(api_url, languages, upload_path)
export const CONTEXT = "notifications";
export const API_URI = api_url+"/"+CONTEXT;
export const UPLOAD_PATH = upload_path+"/"+CONTEXT
export const SEARCHABLE = languages.map(l=>`title_${l}`).concat([]);
export const ROUTE_PREFIX = "/"+CONTEXT;
export const CONTEXT_TITLE = {
  singular: "Notification",
  plural: "Notifications",
}
/**/


export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    // enabled: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "created_at",
  pageNumber: 1,
  pageSize: 10
};

export const defaultEntity = {
  "title_fr": "",
  "title_en": "",
  "title_ar": "",
  "description_fr": "",
  "description_en": "",
  "description_ar": "",
  "enabled":true
};


